module.exports = __webpack_public_path__ + "img/36_21.e91dabd4.png";